var _a;
import config from '@nerdwallet/app-config';
import { Redacted } from './shared';
/**
 * List of RegExp patterns to catch values which should not be logged.
 *
 * These are defined in https://github.com/NerdWallet/app-configs/blob/master/global/default.yml
 *
 
 * @see https://eloquentjavascript.net/09_regexp.html
 */
const sensitiveValuePatterns = ((_a = config === null || config === void 0 ? void 0 : config.API) === null || _a === void 0 ? void 0 : _a.REDACTION_REGEXPS) || [];
const findApplicableRegExp = (str) => sensitiveValuePatterns.find((pattern) => 
// avoid the pitfalls of stateful RegExps by creating a new RegExp for each invocation.
new RegExp(pattern).test(str));
/**
 * This rule gets called for all strings that haven't already been redacted by another rule.
 *
 * If you are adding a RegExp here, please consider if you can _also_ add a rule to filter by
 * property name or some other criteria which might prevent the execution from reaching the string
 * X regexp stage (for instance, we want to avoid logging access_tokens, but if we redact the
 * entire request object (using the redactRequestProperty) rule then we can avoid recursing through
 * the request object, which would help us avoid becoming a performance bottleneck.
 */
export const redactByRegExpPatterns = {
    // Handle values matching certain regexps.
    test: (propertyName, value) => {
        // We don't want to apply this rule to objects which may have a matching .toString because that
        // would prevent the object from being recursed and give us partial logs.
        if (typeof value === 'string') {
            const pattern = findApplicableRegExp(String(value));
            return !!pattern;
        }
        return false;
    },
    /**
     * We need to make sure we redact substrings (consider "123-12-1234" vs. "the ss number is
     * 123-12-1234"). But we only want to redact the sensistive info and not the entire string. This
     * means we must find the appropriate regexp pattern and then use String:replace function.
     */
    replacement: (value) => {
        const str = String(value);
        const applicablePattern = findApplicableRegExp(value);
        /*
        1. This function is only expected to be invoked if we know that an applicablePattern exists
           (because we already called `.test`).
        2. Create a new RegExp because we need the RegExp in _this_ situation to be global, and /g
           alters the RegExp's internal state (.lastIndex).
        */
        return str.replace(new RegExp(applicablePattern, 'g'), Redacted);
    },
};
//# sourceMappingURL=redactByRegExpPattern.js.map